import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { canGetUserMedia } from "./CameraModule/UserMediaManager";
export default {
  get name() {
    return 'ExponentCameraManager';
  },

  get Type() {
    return {
      back: 'back',
      front: 'front'
    };
  },

  get FlashMode() {
    return {
      on: 'on',
      off: 'off',
      auto: 'auto',
      torch: 'torch'
    };
  },

  get AutoFocus() {
    return {
      on: 'on',
      off: 'off',
      auto: 'auto',
      singleShot: 'singleShot'
    };
  },

  get WhiteBalance() {
    return {
      auto: 'auto',
      continuous: 'continuous',
      manual: 'manual'
    };
  },

  get VideoQuality() {
    return {};
  },

  isAvailableAsync: function isAvailableAsync() {
    return _regeneratorRuntime.async(function isAvailableAsync$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", canGetUserMedia());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, null, Promise);
  },
  takePicture: function takePicture(options, camera) {
    return _regeneratorRuntime.async(function takePicture$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _regeneratorRuntime.awrap(camera.takePicture(options));

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, null, Promise);
  },
  pausePreview: function pausePreview(camera) {
    return _regeneratorRuntime.async(function pausePreview$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _regeneratorRuntime.awrap(camera.pausePreview());

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, null, Promise);
  },
  resumePreview: function resumePreview(camera) {
    return _regeneratorRuntime.async(function resumePreview$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _regeneratorRuntime.awrap(camera.resumePreview());

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getAvailableCameraTypesAsync: function getAvailableCameraTypesAsync(camera) {
    return _regeneratorRuntime.async(function getAvailableCameraTypesAsync$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (canGetUserMedia()) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", []);

          case 2:
            _context5.next = 4;
            return _regeneratorRuntime.awrap(camera.getAvailableCameraTypesAsync());

          case 4:
            return _context5.abrupt("return", _context5.sent);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, null, Promise);
  },
  getAvailablePictureSizes: function getAvailablePictureSizes(ratio, camera) {
    return _regeneratorRuntime.async(function getAvailablePictureSizes$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _regeneratorRuntime.awrap(camera.getAvailablePictureSizes(ratio));

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, null, null, null, Promise);
  }
};